import React, { useState } from "react";
import { BsGraphUp } from "react-icons/bs";
import { useSelector } from "react-redux";
import _ from "../../i18n";
import DeltaSideBarFrame from "./DeltaSideBarFrame";
import "./FinancialSheet.local.scss";
import FinancialSheetTree from "./FinancialSheetTree";

export default function Index() {
  const { token, navCommunity, user, collaborator, loggedAs } = useSelector(
    (state) => state.auth
  );
  const { language } = useSelector((state) => state.params);
  const preferences =
    user && navCommunity && user.userOrganizations.length > 0
      ? user.userOrganizations.find(
          (organization) => organization.id === navCommunity.id
        ).authorisation.preferences?.financial
      : {};
  const [showDeltaBar, setShowDeltaBar] = useState(false);

  const renderDeltaBubble = () => {
    return (
      <div className="setting-bubbles" style={{ top: "45%", right: -150 }}>
        <div
          className={`circleSvg 
              ${showDeltaBar ? "active opened" : ""}`}
          onClick={() => setShowDeltaBar(true)}
          style={{ height: 50 }}
        >
          <BsGraphUp size={10} />
          <span style={{ paddingLeft: "1rem", fontSize: "14px" }}>
            {_("delta")}
          </span>
        </div>
      </div>
    );
  };

  const renderDeltaFrame = () => {
    return (
      <div className="fadePage" style={{ width: "100%" }}>
        <div
          className={`sidebar config-sid ${showDeltaBar && "display"}`}
          style={{ width: "100%", background: "none" }}
        >
          <DeltaSideBarFrame
            token={token}
            organization={navCommunity}
            preferences={preferences}
            user={user}
            collaborator={collaborator}
            loggedAs={loggedAs}
            language={language}
            onClose={() => setShowDeltaBar(false)}
          />
        </div>
      </div>
    );
  };

  return (
    <div
      className="page-container page-content"
      style={{ "--overflow-y": showDeltaBar ? "hidden" : "auto" }}
    >
      {renderDeltaBubble()}
      <FinancialSheetTree  />
      {showDeltaBar && renderDeltaFrame()}
    </div>
  );
}
